import React from 'react';
import getReleaseConfig from '../../../config/releaseConfig';

function AboutSourcesGda() {
  const config = getReleaseConfig();
  const sources = config.gda.curatedSources;

  return (
    <div id="section11">
      <h3>Gene-Disease Associations</h3>
      <p>Gene-disease data is organized according to the types of source databases:</p>
      <ul>
        <li className="bullet-item">
          CURATED: GDAs provided by the expert curated resources such as{' '}
          {sources.map((source, index) => (
            <React.Fragment key={index}>
              {index > 0 && (index === sources.length - 1 ? ', and ' : ', ')}
              <a className="tt" target="blank" href={source.url}>
                {source.name}
              </a>
              {source.label && ` (${source.label})`}
            </React.Fragment>
          ))}
          .
        </li>
        <li className="bullet-item">
          MODELS: These data refer to GDAs identified in several models (mouse, rat, zebrafish) using text
          mining approaches and obtained from the database{' '}
          <a className="tt" target="blank" href="https://www.informatics.jax.org/">
            {' '}
            MGD
          </a>{' '}
          (MGD mouse) and{' '}
          <a className="tt" target="blank" href="https://rgd.mcw.edu/">
            {' '}
            RGD
          </a>{' '}
          (RGD rat).
        </li>
        <li className="bullet-item">
          INFERRED: These data refer to GDAs inferred from{' '}
          <a className="tt" target="blank" href="https://hpo.jax.org/app/">
            Human Phenotype Ontology
          </a>{' '}
          (HPO), CHEMBL and the VDAs reported by the GWAS and Phewas catalog, and UK and FinnGen Biobanks. In
          the case of HPO, GDAs are inferred from phenotype-disease and gene-phenotype associations via
          inference through the common phenotypes. For CHEMBL, GDAs are inferred by combining drug–indication
          and drug–target associations. A gene–disease association is established when a drug indicated for a
          disease is known to target a given gene. In the case of VDAs, a GDA is inferred by mapping the
          variant to a gene, only for those variants that are in coding sequences.
        </li>
        <li className="bullet-item">
          CLINICAL TRIALS: GDAs extracted using text mining from clinical trials records available at{' '}
          <a className="tt" target="blank" href="https://clinicaltrials.gov/">
            clinicaltrials.gov
          </a>
          . Disease annotations are obtained from{' '}
          <a className="tt" target="blank" href="https://aact.ctti-clinicaltrials.org/">
            aact.ctti-clinicaltrials.org
          </a>
          .
        </li>
        <li className="bullet-item">
          TEXT MINING MODELS: GDAs identified by text mining from the scientific literature in studies using
          model systems (animal models).
        </li>
        <li className="bullet-item">
          TEXT MINING HUMAN: GDAs identified by text mining from the scientific literature in studies
          performed on human subjects.
        </li>
        <li className="bullet-item">ALL: GDAs from all previous sources.</li>
      </ul>
    </div>
  );
}

export default AboutSourcesGda;
